import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { MappingService } from 'src/app/services/mapping.service';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { IReadingClub } from 'src/app/interfaces/book-store';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';

@Component({
  selector: 'app-add-material-book-club',
  templateUrl: './add-material-book-club.component.html',
  styleUrls: ['./add-material-book-club.component.scss']
})
export class AddMaterialBookClubComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Add reading to class"

  form: FormGroup;
  reading: AbstractControl;

  BOOK_LIST: any;
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddMaterialBookClubComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: BookstoreStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private route: Router,
  ) { }

  async ngOnInit() {
    const { READING } = this.data;
    this.form = this.fb.group({
      reading: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      note: [null]
    })
    this.reading = this.form.controls['reading'];

    if (READING) {
      this.TITLE = "Edit lesson to program";
    }
    const BOOK_LIST = await this.store.fetchBookClub();
    this.BOOK_LIST = MappingService.autoComplete(this.reading, BOOK_LIST, "name");
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { READING, CLASS_KEY } = this.data;
      const { user, selectedCompanyKey } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { reading, note } = f;
      const registerStatus = STATUS_OBJECT.submitted;
      const activity: IReadingClub = {
        key: READING ? READING.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: READING ? READING.created_at : new Date(),
        created_by: READING ? READING.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: READING ? READING.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: READING ? READING.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: reading || null,
        note: note,
        bookKey: reading.key,
        bookRef: this.ds.bookClubRef().doc(reading.key).ref,
        classKey: CLASS_KEY,
        classRef: this.ds.generalPlacementTestRef().doc(CLASS_KEY).ref,
      }

      this.store.addReadingBook(activity, (success, res) => {
        if (success) {
          this.snackBar.open("Book has been added to class materials successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close();
        }
      })
    }
  }
}